import React, { Component } from "react";
import Modal from "react-modal";
import PrettyPrintJson from "./PrettyPrintJson";

class CMTModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      fileIdentifier: this.props.applicationId
        ? this.props.applicationId
        : this.props.webhookId
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleDownload() {
    console.log("fn called");
    var blob = new Blob([JSON.stringify(this.props.data)], {
      type: "application/json"
    });
    var linkSource = URL.createObjectURL(blob);
    var downloadLink = document.createElement("a");
    var fileName = "snapshot_" + this.state.fileIdentifier + ".json";
    if(this && this.props && this.props.data && this.props.data.application && this.props.data.application.retrievalIntervalMonths) {
      fileName = "yca_" + this.state.fileIdentifier + ".json";
    }             
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  handleCloseModal() {
    this.setState({ showModal: false });
    this.props.resetJsonView();
  }
  render() {
    return (
      <div style={{ margin: 10 }}>
        <Modal
          isOpen={this.state.showModal}
          contentLabel="onRequestClose Example"
          onRequestClose={this.handleCloseModal}
          className="Modal"
          overlayClassName="Overlay"
        >
          <a
            className="nav-link jsonDownload"
            id="jsonDownload"
            role="button"
            onClick={this.handleDownload}
          >
            <i
              className="fa fa-download"
              aria-hidden="true"
              title="Download"
            ></i>
          </a>

          <PrettyPrintJson
            data={this.props.data}
            displayDataTypes={false}
            collapsed={1}
          />
          <button className="close customPos" onClick={this.handleCloseModal}>
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal>
      </div>
    );
  }
}

export default CMTModal;
